import { combineReducers, createStore ,applyMiddleware} from "redux";
import UserReducer from "./reducers/user";


const reducers = combineReducers({user : UserReducer, });

export default createStore(reducers,{});